export default __webpack_public_path__ + "static/media/2U.afa4493e.svg";